"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostProfileFields = void 0;
exports.HostProfileFields = [
    'hostId',
    'supplierProfileId',
    'firstName',
    'lastName',
    'bio',
    'facebook',
    'instagram',
    'profilePic',
    'portfolio',
];
//# sourceMappingURL=HostProfile.js.map